export interface SymbiosisCallDataDecode {
    relayRecipient: string;
    otherSideCalldata: string;
}
